import {
	queryOptions,
	useQuery,
	useSuspenseQuery,
} from "@tanstack/react-query";
import { getStaffPersona, getStudentPersona, getStudentPhoto } from "./api";
import { GetStaffPersonaParams } from "@godalming/api-types";
import { isPhotoIdentity } from "./photoLoading";

export const studentPersonaQueryKey = (id: string) => ["persona", id] as const;

export function studentPersonaQueryOptions(id: string) {
	return queryOptions({
		queryKey: studentPersonaQueryKey(id),
		queryFn: ({ signal }) => getStudentPersona(id, signal),
		staleTime: 10 * 60 * 1000, // 10m for metadata
		gcTime: 60 * 60 * 1000, // keep cached for 1h
	});
}

export function useStudentPersona(id: string) {
	return useQuery(studentPersonaQueryOptions(id));
}

export function useStudentPersonaSuspense(id: string) {
	return useSuspenseQuery(studentPersonaQueryOptions(id));
}

export const staffPersonaQueryKey = (params: GetStaffPersonaParams) =>
	["staff-persona", params] as const;

export function staffPersonaQueryOptions(params: GetStaffPersonaParams) {
	return queryOptions({
		queryKey: staffPersonaQueryKey(params),
		queryFn: ({ signal }) => getStaffPersona(params, signal),
		enabled: isPhotoIdentity(params.identifier),
		staleTime: 10 * 60 * 1000, // 10m for metadata
		gcTime: 60 * 60 * 1000, // keep cached for 1h
	});
}

export function useStaffPersona(params: GetStaffPersonaParams) {
	return useQuery(staffPersonaQueryOptions(params));
}

export function useStaffPersonaSuspense(params: GetStaffPersonaParams) {
	return useSuspenseQuery(staffPersonaQueryOptions(params));
}

export const studentPhotoQueryKey = (id: string) =>
	["persona-photo", "student", id] as const;

export function studentPhotoQueryOptions(id: string) {
	return queryOptions({
		queryKey: studentPhotoQueryKey(id),
		queryFn: ({ signal }) => getStudentPhoto(id, signal),
		staleTime: 10 * 60 * 1000, // 10m for metadata
		gcTime: 60 * 60 * 1000, // keep cached for 1h
	});
}

export function useStudentPhoto(id: string) {
	return useQuery(studentPhotoQueryOptions(id));
}

export function useStudentPhotoSuspense(id: string) {
	return useSuspenseQuery(studentPhotoQueryOptions(id));
}
